
import { defineComponent, ref } from 'vue';
import InputText from '@/components/input/InputText.vue';
import { useStore } from 'vuex';
import { POST_DANA_BANTUAN, PUT_DANA_BANTUAN } from "@/store/danaBantuan.module";
import InputPrice from '../input/InputPrice.vue';
import InputSelect from '../input/InputSelect.vue';

export default defineComponent({
  components: {
    InputText,
    InputPrice,
    InputSelect
  },
  props: {
    title: {
      type: String,
      required: true
    },
    id:{
      type: String,
      required: false
    },
    data: {
      type: Object,
      required: false,
      default: () => ({}) // Provide a default object to prevent undefined errors
    }
  },
  setup(props, { emit }) {
    const store = useStore();
    const modalContent = ref(null);
    const isLoading = ref(false);

    const closeModal = () => {
      isLoading.value = false;
      emit('close');
    };

    const formData = {
      id: '',
      data: {} as Record<string, any>
    }

    const updateValue = (params: { key: string; value: any }) => {
      formData.data[params.key] = params.value;
    };

    const handleSubmit = async () => {
      isLoading.value = true;
      try {
        if(props?.id){
          formData.id = props?.id
          await store.dispatch(PUT_DANA_BANTUAN, formData);
        }else{
          await store.dispatch(POST_DANA_BANTUAN, formData);
        }
        closeModal();
      } catch (error:any) {
        alert(error?.response?.data?.message);
        isLoading.value = false;
      }
    };

    return {
      modalContent,
      closeModal,
      handleSubmit,
      updateValue,
      isLoading
    };
  },
});
